interface Toast {
  id: number;
  message: string;
  type: "success" | "error" | "info";
}

const toasts = ref<Toast[]>([]);
let idCounter = 0;

export const useToast = () => {
  const show = (
    message: string,
    type: "success" | "error" | "info" = "info",
    duration?: number,
  ) => {
    const id = idCounter++;
    toasts.value.push({ id, message, type });

    // Auto remove — erros ficam mais tempo visíveis
    const timeout = duration ?? (type === 'error' ? 8000 : 4000);
    setTimeout(() => {
      remove(id);
    }, timeout);
  };

  const remove = (id: number) => {
    toasts.value = toasts.value.filter((t) => t.id !== id);
  };

  return { toasts, show, remove };
};
